export const WebRtcServers = {
    iceServers: [
        {
            urls: [
                "stun:stun1.l.google.com:19302",
                "stun:stun2.l.google.com:19302",
                "stun:stun.relay.metered.ca:80"
            ],
        },
        {
            urls: [
                "turn:standard.relay.metered.ca:80",
                "turn:standard.relay.metered.ca:80?transport=tcp",
                "turn:standard.relay.metered.ca:443",
                "turns:standard.relay.metered.ca:443?transport=tcp",
            ],
            username: "7caa77b5c9bd3cb538c9d418",
            credential: "0KsV2VDhnIVtIYNA"
        }
    ],
};